// extracted by mini-css-extract-plugin
export var hidden = "_59-1";
export var leftPanel = "_59-2";
export var readonlyInspector = "_59-3";
export var rightPanel = "_59-0";